import { fetchReducer } from 'iqvia-shared';
import reduceReducers from 'reduce-reducers';

import apiNameEnums from '../../../Enums/apiNames';

const defaultState = {
  periods: [],
  isLoading: false,
};

const timePeriods = (state = defaultState, { type }) => {
  switch (type) {
    default:
      return state;
  }
};

export default reduceReducers(timePeriods, fetchReducer(apiNameEnums.GET_TIME_PERIODS));



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/reducers/timePeriods.js